import { Stack } from '@mui/material';
import ContentBuilderRow from 'domains/core/components/ContentBuilderRow';
import { VoiceContentAction, VoiceContentStateTypes, VoiceText } from '../types';
import MessageInputWithMergeTags from '../MessageInputWithMergeTags';
import { addVoicemailMessage, removeVoicemailMessage } from '../voiceCallActions';
import FallbackBuilder from './FallbackBuilder';

type Props = {
    dispatchVoiceContentAction: React.Dispatch<any>;
    isContentLoading: boolean;
    voiceContentState: VoiceContentStateTypes;
};

const VoicemailFallbackBuilder = ({
    dispatchVoiceContentAction,
    isContentLoading,
    voiceContentState: state,
}: Props) => (
    <Stack>
        <ContentBuilderRow
            title="Voicemail Message"
            subtitle="Enter the message your contact will hear if they miss your call. Make sure it's clear, focused, and encourages them to take action."
            content={
                <MessageInputWithMergeTags
                    handleMessageChange={(value: string) => {
                        if (!!value.length) {
                            dispatchVoiceContentAction(
                                addVoicemailMessage({
                                    message: [{ text: value, type: 'text' }],
                                    type: VoiceContentAction.VOICEMAIL,
                                })
                            );
                        } else {
                            dispatchVoiceContentAction(removeVoicemailMessage());
                        }
                    }}
                    isMessageLoading={isContentLoading}
                    message={(state.voiceJson?.voicemail?.message[0] as VoiceText)?.text ?? ''}
                />
            }
        />
        <FallbackBuilder
            dispatchVoiceContentAction={dispatchVoiceContentAction}
            isContentLoading={isContentLoading}
            voiceContentState={state}
        />
    </Stack>
);

export default VoicemailFallbackBuilder;
